export const CreditorPortalNote = {
  initFormData: {
    note: ""
  },
  isSending: false
};
